class CollectionLoadMore extends HTMLElement {
  constructor() {
    super()

    this.currentPage = 1
  }

  connectedCallback() {
    if (this.isNotPageOne()) this.fetchPreviousProducts()

    this.addEventListener('loadMore', (event) => {
      event.preventDefault()
      this.classList.add('is-loading')
      this.fetchSections(event.target.dataset.href)
    })

    window.addEventListener('beforeunload', this.saveScrollPosition.bind(this))

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }

    document.addEventListener('DOMContentLoaded', this.scrollToSavedScrollPosition.bind(this))
    
  }

  isNotPageOne() {
    if (this.dataset.noPrevious == 'true') return
    const url = window.location.search;
    const urlParams = new URLSearchParams(url)
    this.currentPage = urlParams.get('page')
    return this.currentPage > 1
  }

  async fetchPreviousProducts() {
    let url = window.location.search;
    let urlParams = new URLSearchParams(url)
    for (let index = 1; index < this.currentPage; index++) {
      urlParams.set('page', index)
      const newUrl = `${window.location.pathname}?${urlParams.toString()}&view=no-previous`;
      await fetch(newUrl)
      .then((response) => response.text())
        .then((responseText) => {
          const parser = new DOMParser()
          const html = parser.parseFromString(responseText, 'text/html')
          this.renderPreviousProducts(html)
      })
    }

    this.scrollToSavedScrollPosition()
  }

  fetchSections(url) {
    if (!url) return
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const parser = new DOMParser()
        const html = parser.parseFromString(responseText, 'text/html')
        this.renderProducts(html)
        this.renderLoadMore(html)
        window.history.pushState('', '', url)
      })
  }

  renderPreviousProducts(response) {
    const responseProductGrid = response.querySelector('.js-product-grid')
    const destinationProductGrid = document.querySelector('.js-product-grid')
    const responseMainSearchResults = response.querySelector('.main-search__results')
    const destinationMainSearchResults = document.querySelector('.main-search__results')

    if (responseMainSearchResults && destinationMainSearchResults) {
      const dataProductsGrid = responseMainSearchResults.querySelector('[data-products-grid]')
      const destinationProductGridSearch = document.querySelector('#searchresults-container [data-products-grid]')

      const lastProductCard = dataProductsGrid.querySelector('li:last-child')
      lastProductCard.classList.add('last-item')
      destinationProductGridSearch.classList.add('load-more')

      const productCards = dataProductsGrid.innerHTML
      if (dataProductsGrid) {
        const lastItem = destinationMainSearchResults.querySelector('.last-item');
        lastItem.insertAdjacentHTML('afterend', productCards);
        lastItem.classList.remove('last-item');
      }
    }
  }

  renderProducts(response) {
    const responseProductGrid = response.querySelector('.js-product-grid')
    const destinationProductGrid = document.querySelector('.js-product-grid')
    const responseMainSearchResults = response.querySelector('.main-search__results')
    const destinationMainSearchResults = document.querySelector('.main-search__results')

    if (responseProductGrid && destinationProductGrid) {
        const dataProductsGrid = responseProductGrid.querySelector('[data-products-grid]')

        if (dataProductsGrid) {
            destinationProductGrid.appendChild(dataProductsGrid)
        }
    }

    if (responseMainSearchResults && destinationMainSearchResults) {
        const dataProductsGrid = responseMainSearchResults.querySelector('[data-products-grid]')
        const destinationProductGridSearch = document.querySelector('#searchresults-container [data-products-grid]')
        destinationProductGridSearch.classList.add('load-more')
        const productCards = dataProductsGrid.innerHTML

        console.log(destinationProductGridSearch, 'destinationProductGridSearch')
        if (dataProductsGrid) {
          destinationProductGridSearch.insertAdjacentHTML('beforeend', productCards)
        }
    }
  }

  renderLoadMore(response) {
    const responseHTML = response.querySelector('[data-load-more]')
    const destinationHTML = document.querySelector('[data-load-more]')

    if (!responseHTML && !destinationHTML) return

    console.log(responseHTML.innerHTML)
    const collectionLoadMoreElem = responseHTML.querySelector('collection-load-more')
    collectionLoadMoreElem.setAttribute('data-no-previous', 'true')
    destinationHTML.innerHTML = responseHTML.innerHTML
  }

  saveScrollPosition() {
    localStorage.setItem('load-more-scroll-position', window.scrollY)
  }

  removeSavedScrollPosition() {
    localStorage.removeItem('load-more-scroll-position')
  }

  scrollToSavedScrollPosition() {
    const savedScrollPosition = localStorage.getItem('load-more-scroll-position');
    console.log(savedScrollPosition, window.scrollY)
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition, 10));
    }
  }
}

customElements.define('collection-load-more', CollectionLoadMore)
